import { Link as RouterLink } from 'react-router-dom'
import { DarkMode, LightMode } from '@mui/icons-material'
import { IconButton, Link, Toolbar, Stack } from '@mui/material'
import Logo from '@/assets/Logo'
import useLocalStorage from '@/hooks/useLocalStorage'
import useIsSuperUser from '@/services/hooks/useIsSuperUser'
import RootOrganizationPicker from '@/components/organizations/RootOrganizationPicker'
import DemoModeInfo from './DemoModeInfo'
import ProfileMenu from './ProfileMenu'
import SuperUserMenu from './SuperUserMenu'

export default function AppTopBarLite() {
  const isSuperUser = useIsSuperUser()
  const [themeMode, setThemeMode] = useLocalStorage(
    'pixydocs-theme-mode',
    'dark',
  )

  return (
    <header>
      <Toolbar
        component={Stack}
        direction="row"
        disableGutters
        justifyContent="space-between"
        variant="dense"
        sx={{ py: '2px' }}
      >
        <Stack direction="row">
          <Link
            ml={1}
            mb={2.5}
            to="."
            component={RouterLink}
            sx={{
              position: 'relative',
              '&::after': {
                content: '"LITE"',
                fontSize: '0.7em',
                letterSpacing: '0.05em',
                color: 'warning.main',
                position: 'absolute',
                top: '3px',
                right: '-30px',
              },
            }}
          >
            <Logo />
          </Link>
        </Stack>
        <DemoModeInfo />
        <Stack direction="row" alignItems="center">
          <RootOrganizationPicker />
          <IconButton
            size="small"
            onClick={() =>
              setThemeMode((prev) => (prev === 'dark' ? 'light' : 'dark'))
            }
          >
            {themeMode === 'dark' ? <DarkMode /> : <LightMode />}
          </IconButton>
          <ProfileMenu isLite />
          {isSuperUser && <SuperUserMenu />}
        </Stack>
      </Toolbar>
    </header>
  )
}
